"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useTrackDimension;

var _useWebChatAPIContext2 = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useTrackDimension() {
  var _useWebChatAPIContext = (0, _useWebChatAPIContext2.default)(),
      trackDimension = _useWebChatAPIContext.trackDimension;

  return trackDimension;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VUcmFja0RpbWVuc2lvbi50cyJdLCJuYW1lcyI6WyJ1c2VUcmFja0RpbWVuc2lvbiIsInRyYWNrRGltZW5zaW9uIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxpQkFBVCxHQUFnRTtBQUM3RSw4QkFBMkIscUNBQTNCO0FBQUEsTUFBUUMsY0FBUix5QkFBUUEsY0FBUjs7QUFFQSxTQUFPQSxjQUFQO0FBQ0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VXZWJDaGF0QVBJQ29udGV4dCBmcm9tICcuL2ludGVybmFsL3VzZVdlYkNoYXRBUElDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlVHJhY2tEaW1lbnNpb24oKTogKG5hbWU6IHN0cmluZywgZGF0YTogYW55KSA9PiB2b2lkIHtcbiAgY29uc3QgeyB0cmFja0RpbWVuc2lvbiB9ID0gdXNlV2ViQ2hhdEFQSUNvbnRleHQoKTtcblxuICByZXR1cm4gdHJhY2tEaW1lbnNpb247XG59XG4iXX0=